<template>
    <form class="sorting-form">

        <div class="count">
            {{ count }} Items
        </div>

        <label class="ml-auto sorting-label">
            Sort <span class="d-none d-sm-inline">by:</span>
        </label>

        <select @change="$emit('sort-change', $event.target.value)" :value="sort">
            <option v-for="(name, key) in sorts" :key="key" :value="key">{{ name }}</option>
        </select>

        <a v-show="mobile" href="#" v-b-toggle.catalog-filters class="filter-button">
            Filter <i class="far fa-angle-down"></i>
        </a>

    </form>
</template>

<script>
    export default {
        props: {
            count: Number,
            mobile: Boolean,
            sorts: Object,
            sort: String,
        }
    }
</script>

<style lang="scss" scoped>

    @import "@/scss/common.scss";

    form.sorting-form {

        display: flex;
        align-items: center;

        margin: $spacer $spacer*-1;
        padding: 0 $spacer;

        font-size: 12px;

        @media (min-width: map-get($grid-breakpoints, "sm" )) {
            font-size: 16px;
            margin: $spacer 0;
            padding: 0;
        }

        border-top: 1px solid $light;
        border-bottom: 1px solid $light;

        label, .count {
            margin: 7.5px 0;
            // padding: 9px 20px;
            padding-right: 7.5px;
            margin: 0;
        }

        select {
            @include border-radius(10px);

            margin: 7.5px 0;
            padding: 3px 10px;

            font-size: 12px;
            letter-spacing: 0;

            // height: 40px;
            color: $link-color;
            // box-shadow: none;
            // border: 1px solid $dark;
            @media (min-width: map-get($grid-breakpoints, "sm" )) {
                font-size: 16px;
            }
        }

        a.filter-button {

            display: block;
            height: 100%;
            margin: -7.5px $spacer/2;
            margin-right: 0;
            padding: 10px 5px;
            white-space: nowrap;

            &[aria-expanded=true] {
                background-color: $primary;
                color: white;
            }

        }


        .filter-reset {
            font-size: 12px;
            letter-spacing: 0.5pt;
            a { color: $primary; }
        }
    }

</style>
